$(document).ready(function () {
    // Helpers
    const isMobile = () => $(window).width() < 824;
    const isDesktop = () => $(window).width() > 1200;

    switchDiv();

    // Utility Classes
    $('li:first-child').addClass('first');
    $('li:last-child').addClass('last');
    $('[href="#"]').attr('href', 'javascript:;');

    // Toggles
    $('.menu-Bar').click(() => $('body, .menuWrap, .menu-Bar').toggleClass('open ovr-hiddn'));

    $('.loginUp').click(() => $('.LoginPopup, .overlay').fadeIn());
    $('.signUp').click(() => $('.signUpPop, .overlay').fadeIn());
    $('.closePop, .overlay').click(() => $('.popupMain, .overlay').fadeOut());

    // Tab Switch
    $('[data-targetit]').click(function () {
        const target = $(this).data('targetit');
        $(this).addClass('active').siblings().removeClass('active');
        $('.' + target).fadeIn().siblings('[class^="box-"]').hide();
        $('.tabViewList').slick('setPosition', 0);
    });

    // Accordion
    $('.accordion-list > li > .answer').hide();
    $('.accordion-list > li').click(function () {
        const $this = $(this);
        if ($this.hasClass('active')) {
            $this.removeClass('active').find('.answer').slideUp();
        } else {
            $('.accordion-list > li.active .answer').slideUp();
            $('.accordion-list > li.active').removeClass('active');
            $this.addClass('active').find('.answer').slideDown();
        }
    });

    // Search
    $('.searchBtn').click(() => {
        $('.searchWrap').addClass('active');
        $('.overlay').fadeIn();
        const $input = $('.searchWrap input').focus();
        $input.on('focusout', () => {
            $('.searchWrap').removeClass('active');
            $('.overlay').fadeOut();
            $('body').removeClass('ovr-hiddn');
        });
    });

    // Slick Sliders
    initSliders();

    // Sticky Header
    $(window).scroll(() => $('header').toggleClass('sticky', $(window).scrollTop() >= 1));

    // Dynamic Popup Content
    bindDynamicPopup('.popdynamic', '.pckg', '.title', '.price .amount');
    bindDynamicPopup('.popbtn2', '.pckg2', '.label', '.price');

    $('.popstatic').click(() => {
        $('.centercont.static').removeClass('d-none');
        $('.centercont.dynamic').addClass('d-none');
        $('#popstatic, .overlay').fadeIn();
        $('.centercont h4').html('in Just <span>$99</span>');
    });

    $('.closeico, .overlay').click(() => $('.popupmain, .overlay').fadeOut());

    // Accordion Tabs
    $('.at-title').click(function () {
        const $this = $(this);
        $this.toggleClass('active')
            .next('.at-tab').slideToggle()
            .parent().siblings().find('.at-tab').slideUp().prev().removeClass('active');
    });

    // Mega Dropdown Hover Handlers
    function handleDropdowns(selector) {
        if (isDesktop()) {
            $(selector + '.hover').hover(function () {
                const $this = $(this);
                $(selector).not($this).find('.dropdown').slideUp(100);
                $(selector).not($this).find('.chev').removeClass('rotate');
                $this.children('.dropdown').slideToggle(100);
                $this.find('.chev').toggleClass('rotate');
            });
        } else {
            $(selector + '.hover').click(function () {
                const $this = $(this);
                $(selector).not($this).find('.dropdown').slideUp(100);
                $(selector).not($this).find('.chev').removeClass('rotate');
                $this.children('.dropdown').slideToggle(100);
                $this.find('.chev').toggleClass('rotate');
            });
        }
        $(selector + '.click').click(function () {
            const $this = $(this);
            $(selector).not($this).find('.dropdown').slideUp(100);
            $(selector).not($this).find('.chev').removeClass('rotate');
            $this.find('.dropdown').slideToggle(100);
            $this.find('.chev').toggleClass('rotate');
        });
    }
    
    handleDropdowns('.has-child');
    handleDropdowns('.has-child-mega');
  
});

function bindDynamicPopup(triggerSelector, parentSelector, titleSelector, priceSelector) {
    $(triggerSelector).click(function () {
        const $parent = $(this).closest(parentSelector);
        const title = $parent.find(titleSelector).html();
        const price = $parent.find(priceSelector).html();
        const rel = $(this).attr('rel');

        $('input[name="pkg_key"]').val(rel);
        $('#popupform input#popuppackage').val(rel);
        $('.centercont.dynamic h3 span').html(title);
        $('.centercont h4').html('In Just <span>' + price + '</span>');

        $('.centercont.static').addClass('d-none');
        $('.centercont.dynamic').removeClass('d-none');
        $('#popdynamic, .overlay').fadeIn();
        $('.LoginPopup').addClass('price-margin');
    });
}

function initSliders() {
    const slickSettings = [
        { selector: '.index-slider', settings: { slidesToShow: 2, arrows: true } },
        { selector: '.index-slider-news', settings: { slidesToShow: 3, arrows: true } },
        { selector: '.testimonials-slider', settings: { slidesToShow: 1, arrows: true } },
        { selector: '.slider-for', settings: { slidesToShow: 1, fade: true, asNavFor: '.slider-nav', arrows: false } },
        { selector: '.slider-nav', settings: { slidesToShow: 3, asNavFor: '.slider-for', focusOnSelect: false, arrows: false } },
        { selector: '.clientSlider', settings: {
            slidesToShow: 5, autoplay: true, arrows: false,
            responsive: [
                { breakpoint: 1024, settings: { slidesToShow: 3, dots: true } },
                { breakpoint: 600, settings: { slidesToShow: 2 } },
                { breakpoint: 480, settings: { slidesToShow: 2 } },
            ]
        }},
        { selector: '.clientSlider2', settings: {
            slidesToShow: 5, autoplay: true, arrows: false,
            responsive: [
                { breakpoint: 1024, settings: { slidesToShow: 3, dots: true } },
                { breakpoint: 600, settings: { slidesToShow: 2 } },
                { breakpoint: 480, settings: { slidesToShow: 2 } },
            ]
        }},
        { selector: '.testi-slider-2', settings: {
            slidesToShow: 3, autoplay: true, dots: true, arrows: false,
            responsive: [
                { breakpoint: 1025, settings: { slidesToShow: 3 } },
                { breakpoint: 885, settings: { slidesToShow: 2 } },
                { breakpoint: 600, settings: { slidesToShow: 1 } },
            ]
        }},
        { selector: '.resultSlide', settings: {
            slidesToShow: 1, autoplay: true, dots: true, arrows: true,
            prevArrow: "<span class='arr-left'><i class='fal fa-arrow-left'></i></span>",
            nextArrow: "<span class='arr-right'><i class='fal fa-arrow-right'></i></span>"
        }},
        { selector: '.mainBannerSlide', settings: {
            slidesToShow: 1, autoplay: true, fade: true, arrows: false, dots: true
        }},
        { selector: '.slick-center', settings: { centerMode: true, centerPadding: 0, slidesToShow: 1 } },
    ];

    slickSettings.forEach(slider => $(slider.selector).slick(slider.settings));
}

function switchDiv() {
    if ($(window).outerWidth() <= 768) {
        $('.topAppendTxt').each(function () {
            const clone = $(this).find('.cloneDiv').clone(true);
            $(this).find('.cloneDiv').remove();
            $(this).append(clone);
        });
    }
}

$(window).on('load', function () {
    const currentUrl = window.location.href.split('/').pop();
    $('ul.menu li a').each(function () {
        const $this = $(this);
        if ($this.attr('href') === currentUrl) {
            $this.closest('li').addClass('active');
            $('ul.menu li.first').removeClass('active');
        }
    });
});

$(window).on('scroll', function () {
    if ($('.goto').length && $(window).scrollTop() >= $('.goto').offset().top - $(window).height()) {
        if (!$('.goto').hasClass('animated')) {
            $('.count').each(function () {
                $(this).prop('Counter', 0).animate({ Counter: $(this).text() }, {
                    duration: 4000,
                    easing: 'swing',
                    step: function (now) {
                        $(this).text(Math.ceil(now).toLocaleString());
                    },
                });
            });
            $('.goto').addClass('animated');
        }
    }
});

function aosInit() {
    AOS.init({ duration: 1000, easing: 'ease-in-out', once: true, mirror: false });
}
window.addEventListener('load', aosInit);